var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"p-topSearchKeyword u-only--sp"},[_c('div',{staticClass:"container"},[_c('search-keyword-form',{attrs:{"brand":_vm.brandEnglishName}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }